import React, { useContext } from "react";
import styled, { css } from "styled-components";
import OnColorContext from "../../../contexts/OnColorContext";
import ConditionalWrapper from "../../../helpers/ConditionalWrapper";
import breakpoint from "../../../utils/breakpoint";
import getBorderColor from "../../../utils/getBorderColor";
import space from "../../../utils/space";
import unit from "../../../utils/unit";
import CheckboxAtm from "../../atoms/CheckboxAtm";
import TextAtm from "../../atoms/TextAtm";
import TooltipMol from "../TooltipMol";
export var defaultProps = {
  gutterSpace: {
    small: 1,
    mediumUp: 2
  }
};
var gutterBasicStyles = function gutterBasicStyles($gutterSpace) {
  if ($gutterSpace.small) {
    return css(["> :first-child{margin-right:", ";}", "{> :first-child{margin-right:", ";}}"], space($gutterSpace.small), breakpoint("medium"), space($gutterSpace.mediumUp));
  }
  return css(["> :first-child{margin-right:", ";}"], space($gutterSpace));
};
var StyledLabel = styled.label.withConfig({
  componentId: "sc-76kb53-0"
})(function (_ref) {
  var _ref$$gutterSpace = _ref.$gutterSpace,
    $gutterSpace = _ref$$gutterSpace === void 0 ? defaultProps.gutterSpace : _ref$$gutterSpace,
    $isInHorizontalGroup = _ref.$isInHorizontalGroup;
  return css(["", ";display:flex;position:relative;align-items:", ";cursor:pointer;> :first-child{flex-shrink:0;}"], gutterBasicStyles($gutterSpace), $isInHorizontalGroup ? "flex-start" : "center");
});
export var TooltipWrapper = styled.div.withConfig({
  componentId: "sc-76kb53-1"
})(function (_ref2) {
  var $onColor = _ref2.$onColor,
    theme = _ref2.theme;
  return css(["position:relative;border-bottom:", ";&:hover{border-color:", ";}"], "".concat(unit(1), " dashed ").concat(getBorderColor(theme, $onColor, "medium")), getBorderColor(theme, $onColor, "low"));
});
function CheckboxWithLabelMol(_ref3) {
  var text = _ref3.text,
    typography = _ref3.typography,
    _ref3$gutterSpace = _ref3.gutterSpace,
    gutterSpace = _ref3$gutterSpace === void 0 ? defaultProps.gutterSpace : _ref3$gutterSpace,
    emphasis = _ref3.emphasis,
    onChange = _ref3.onChange,
    isChecked = _ref3.isChecked,
    isHighlighted = _ref3.isHighlighted,
    isRequired = _ref3.isRequired,
    hasError = _ref3.hasError,
    tooltipText = _ref3.tooltipText,
    isInHorizontalGroup = _ref3.isInHorizontalGroup,
    title = _ref3.title;
  var onColor = useContext(OnColorContext);
  return /*#__PURE__*/React.createElement(StyledLabel, {
    $gutterSpace: gutterSpace,
    $isInHorizontalGroup: !!isInHorizontalGroup,
    title: title,
    "aria-label": title
  }, /*#__PURE__*/React.createElement(CheckboxAtm, {
    onChange: onChange,
    isChecked: isChecked,
    isHighlighted: isHighlighted,
    isRequired: isRequired,
    hasError: hasError
  }), /*#__PURE__*/React.createElement(ConditionalWrapper, {
    condition: !!tooltipText,
    wrapper: function wrapper(children) {
      return /*#__PURE__*/React.createElement(TooltipWrapper, {
        $onColor: onColor
      }, children, /*#__PURE__*/React.createElement(TooltipMol, {
        isOverlappingRelativeContainer: true
      }, tooltipText));
    }
  }, /*#__PURE__*/React.createElement(TextAtm, {
    typography: typography,
    emphasis: emphasis
  }, text)));
}
export default CheckboxWithLabelMol;